import { jsx } from "react/jsx-runtime";
import { isEditor } from "../../utils/isEditor.esm.js";
import HelocCalculator from "./HelocCalculator.esm.js";
import { FieldConfig } from "./HelocCalculator.utils.esm.js";
const HelocCalculatorBlock = {
  Component: ({
    attrs
  }) => {
    const {
      homeValue,
      loanBalance
    } = attrs;
    const defaultValues = {
      homeValue,
      loanBalance
    };
    return /* @__PURE__ */ jsx(HelocCalculator, { ...{
      defaultValues
    }, editorMode: isEditor() }, isEditor() ? JSON.stringify(defaultValues) : void 0);
  },
  metadata: {
    version: "1.0",
    name: "constellation/heloc-calculator",
    title: "Home Equity Line of Credit (HELOC) Calculator",
    description: "See if you qualify for a home equity line of credit.",
    icon: "calculator",
    keywords: ["mortgages", "calculators", "heloc", "home", "equity"],
    category: "Calculators",
    supports: {
      customClassName: false,
      html: false
    },
    attributes: {
      [FieldConfig.homeValue.name]: {
        type: "number",
        label: "Default home value",
        default: 4e5,
        control: "number"
      },
      [FieldConfig.loanBalance.name]: {
        type: "number",
        label: "Default loan balance",
        default: 3e5,
        control: "number"
      }
    }
  }
};
export {
  HelocCalculatorBlock as default
};
